var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerimetrionAirports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#0D5093"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3826_338",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3826_338",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsSAAALEgHS3X78AAAFHElEQVR4nO2c23HjNhRAjzP7v+og7CAiWUCUCqIOllvBOh3IHaiDyBVE24H8Hz3cgdSBVYHygcuYlvgACfCStnFmNLZlEYCPwIuLh3x3uVwI9M8vQzfgsxBEKxFEKxFEKxFEKxFEKxFEKxFEKxFEKxFEKxFEK/HF5eLtbh8BETAr+fUEmJY8HwG/AidgkSbxyqUN74U7l0Wl7W4/ATbAbw5t+BTCnUSDN9nwwYU7iwavsmGkwre7/QwTIiN5FHkBDsAhTeJ12fVeREtDqmSfgEy+P6RJ/CKxfQF8qylyUOHy98zl8WeLS8/AGtP2Y/6kN9GFxm24lf2YJnFW8vqIkQmXNt1jOsdXx+Ie0iRegGfR0F62XBMxsHDLNnThMU3izLto6CZbrotQFi6xdwH83vDSEyYkHIAjcEyT+CjXTzDxO6P8LnjoRTR0ly3XRvQsfLvbzzEhok7wGVgBy2K8bSg3A5a8FX7uTbRU2lm2XB/hWbiIWGAmTV7KLKljCuyLz/UqWip1ki1lRDgIlzZkmB5cJ/gJWLmGJXkz/y4+17toqXiKkX0dv6xlSzkRLYSL4Ht51GUQT3LNxrYtFe2bSPt+XJevIloa4UW2lBVhJ3xSUt+bujHx99Cm/oo2ZdzG5pxYTbQ0xptsKS+iW0r2yNWEoguFOyajOiR9T5N4pSoa/MuWMiOahZ8xPW6ZJvFLl3oK9dmEpBMwz+8WddHQj2wpN+JW+InXFM1VcFn5ZTxc1zeIaOhPtpQdYYRsfExspK33NN8xN2scOYOJhn5l+8By1mgVkgYVDeOULRlERr3gE0bwyiYkDS4axiO7z1njKETDcLItUzQwk5pl1cJ+E06bs56ZYFbFrqfq37a7Pb5la88aG3t0IV4daLGKZYvlgHMCZj7qbpGieZnU5FSKrolXT5i8dO2Sl1ouU3pbe26Roq3ooUO9Ed3idsobtcaMuhvbCi0HHC+raFLfDE8pmgt3l8slv50y7ASXkac666qe0EKwczws1JdhccfgeHfacPfvdjcH/ml43SNmi71puwfgJ6bh6suUoLOw34W8R2+4lXgTrwo7xHPq/5D8emheptRaRQOPb2hbctETTFZx3ci4aq1WBrM53XaNfQtuumN+YjrMxqU+F/4fDCsmDGcgqotfhW2ijPqTSvmAs/IgOGKAFM2F66wj42qvC3hOk7jsVOgN8mZlvN1297kOPJOyB0nRXLjJo7e7/ZLbPa8u201zzABqtejSUNaMEaRoLpROWCoGx7/SJF5qNKrQjgwTf+tCklqK5kKV6KrB8Q+NAWWsKZoLdVPwqsFx2kfsGyLn1qR2UalqcMQs8Hi5TVvMSgdP0VywWb1bcTvK+9zXezcpmgu169EiY17yq02XygqHuzM8Hy4cO00L/3Nub+fvLQ4U5sdZp1JW00cvRp2iudAkenL18xmYSU8/YD67kTOTr5E8ptivBL6LFM2FJtHHq5+/4vdE/DOm9648ljlKbAbDNe0+LNPEM687NEeP5Y4aq13w7W6/oHkJsoonTJjZYE4OfcjQ0ESr4wYyiZnxGrtn8nVTeNlRHofPKrWM0Zzr+OiE/26gRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtRBCtxJvjBoVPMgX8cZ8m8eH6XEeE3SevAvZMIIQONYJoJcJxAyVCj1YiiFYiiFYiiFYiiFYiiFYiiFYiiFYiiFYiiFbiP97H+bymoDYmAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerimetrionAirports);
export default __webpack_public_path__ + "static/media/perimetrion_airports.24ee6fe664c10a390c47837e7035746c.svg";
export { ForwardRef as ReactComponent };